import {
  listCurrencies as publicListCurrencies,
  convertCurrency as publicConvertCurrency,
  getConversionRate as publicGetConversionRate,
} from './ecommerce-currency-converter-v1-currency-rate-currencies.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const listCurrencies: MaybeContext<
  BuildRESTFunction<typeof publicListCurrencies> & typeof publicListCurrencies
> = /*#__PURE__*/ createRESTModule(publicListCurrencies);
export const convertCurrency: MaybeContext<
  BuildRESTFunction<typeof publicConvertCurrency> & typeof publicConvertCurrency
> = /*#__PURE__*/ createRESTModule(publicConvertCurrency);
export const getConversionRate: MaybeContext<
  BuildRESTFunction<typeof publicGetConversionRate> &
    typeof publicGetConversionRate
> = /*#__PURE__*/ createRESTModule(publicGetConversionRate);

export {
  CurrencyRate,
  ListCurrenciesRequest,
  ListCurrenciesResponse,
  Currency,
  ConvertCurrencyRequest,
  DecimalValue,
  ConvertCurrencyResponse,
  ConversionRateRequest,
  ConversionRateResponse,
  ConvertCurrencyIdentifiers,
  GetConversionRateIdentifiers,
} from './ecommerce-currency-converter-v1-currency-rate-currencies.universal.js';
